export default function getDPI() {
  const div = document.createElement('div');
  div.style.width = div.style.height = '1in';
  div.style.position = 'absolute';
  div.style.visibility = 'hidden';
  document.body.appendChild(div);
  const dpi = div.offsetHeight;
  document.body.removeChild(div);
  return dpi;
}